<!-- MasterBook料金表示 -->
<template>
  <div class="column">
    <!-- 料金 -->
    <h2 class="column-title">{{ $t("common.priceLabel") }}</h2>

    <!-- MasterBook.display_priceを表示 -->
    <div class="column-body" v-html="newlineConvert(price)" />
  </div>
</template>

<script>
export default {
  name: "MbDisplaypriceDisp",
  props: {
    price: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.column {
  margin-top: 15px;
  .column-title {
    margin: 18px 0 5px 0;
    font-size: 15px;
    font-weight: bold;
    color: #777777;
  }

  .column-body {
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    color: #ffb206;
    white-space: pre-line;
    line-height: 1.5rem;
    margin-bottom: 10px;
  }
}
</style>
